import { SoftErrorLabel } from "@soft-db/ui";
import AlertSchedulerTimePicker from "./AlertSchedulerTimePicker";

export default defineComponent({
	name: "AlertSchedulerDualTimePicker",
	props: {
		start: Number,
		end: Number,
		startAvailableRange: Array as PropType<number[]>,
		endAvailableRange: Array as PropType<number[]>,
		startNextDayBetween: Array as PropType<number[]>,
		endNextDayBetween: Array as PropType<number[]>,
		startErrors: Array as PropType<string[]>,
		endErrors: Array as PropType<string[]>,
	},
	setup(props) {
		const { t } = useI18n();

		const start = useVModel(props, "start");
		const end = useVModel(props, "end");

		return () => (
			<div class="grid grid-cols-2 gap-4">
				<div class="space-y-1">
					<AlertSchedulerTimePicker
						v-model={start.value}
						label={t("dashboard.from")}
						availableRange={props.startAvailableRange}
						nextDayBetween={props.startNextDayBetween}
					/>
					<SoftErrorLabel errors={props.startErrors} />
				</div>
				<div class="space-y-1">
					<AlertSchedulerTimePicker
						v-model={end.value}
						label={t("dashboard.to")}
						availableRange={props.endAvailableRange}
						nextDayBetween={props.endNextDayBetween}
					/>
					<SoftErrorLabel errors={props.endErrors} />
				</div>
			</div>
		);
	},
});
